var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "span",
        { staticClass: "version" },
        [
          _c("NewBadge", {
            staticClass: "new-label",
            attrs: { label: _vm.deviceString("newResourceLabel") },
          }),
          _c("span", { staticClass: "version-available" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$tr("versionAvailable", { version: _vm.version })) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _c("KButton", {
        attrs: {
          text: _vm.$tr("viewChangesAction"),
          appearance: "basic-link",
          primary: false,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }